import React from 'react';

type ShortcutItem = {
    label: string;
    keys: string[];
    description?: string;
};

type ShortcutSection = {
    title: string;
    items: ShortcutItem[];
};

const sections: ShortcutSection[] = [
    {
        title: 'Editor de laudos',
        items: [
            { label: 'Salvar', keys: ['Ctrl/Cmd', 'S'] },
            { label: 'Desfazer', keys: ['Ctrl/Cmd', 'Z'] },
            { label: 'Refazer', keys: ['Ctrl/Cmd', 'Shift', 'Z'] },
            {
                label: 'Exportar laudo como JSON',
                keys: ['Ctrl/Cmd', 'Shift', 'E'],
            },
            {
                label: 'Alternar painel esquerdo',
                keys: ['Ctrl/Cmd', 'B'],
            },
            {
                label: 'Alternar painel direito',
                keys: ['Ctrl/Cmd', 'Shift', 'B'],
            },
        ],
    },
    {
        title: 'Blocos de instrumentos',
        items: [
            { label: 'Selecionar area', keys: ['Arraste em area vazia'] },
            { label: 'Estender selecao', keys: ['Shift', 'Clique ou arraste'] },
            { label: 'Adicionar/remover da selecao', keys: ['Ctrl/Cmd', 'Clique'] },
            { label: 'Copiar bloco(s)', keys: ['Ctrl/Cmd', 'C'] },
            { label: 'Recortar bloco(s)', keys: ['Ctrl/Cmd', 'X'] },
            { label: 'Colar bloco(s)', keys: ['Ctrl/Cmd', 'V'] },
            { label: 'Excluir selecao', keys: ['Delete'] },
            { label: 'Limpar selecao', keys: ['Esc'] },
        ],
    },
    {
        title: 'Zoom do preview',
        items: [
            { label: 'Aproximar', keys: ['Ctrl/Cmd', '+'] },
            { label: 'Afastar', keys: ['Ctrl/Cmd', '-'] },
            { label: 'Resetar zoom', keys: ['Ctrl/Cmd', '0'] },
            { label: 'Zoom com mouse', keys: ['Ctrl/Cmd', 'Scroll'] },
        ],
    },
    {
        title: 'Tabela de instrumentos',
        items: [
            { label: 'Editar celula', keys: ['Enter'] },
            { label: 'Limpar selecao', keys: ['Esc'] },
            { label: 'Mover selecao', keys: ['Setas'] },
            { label: 'Ir para proxima celula', keys: ['Tab'] },
            { label: 'Voltar para celula anterior', keys: ['Shift', 'Tab'] },
            { label: 'Mesclar celulas', keys: ['Ctrl/Cmd', 'M'] },
            { label: 'Desmesclar celulas', keys: ['Ctrl/Cmd', 'Shift', 'M'] },
        ],
    },
];

const KeyCombo: React.FC<{ keys: string[] }> = ({ keys }) => {
    return (
        <div className="flex flex-wrap items-center gap-1">
            {keys.map((key, index) => (
                <span key={`${key}-${index}`} className="inline-flex items-center gap-1">
                    {index > 0 && <span className="text-muted-foreground">+</span>}
                    <kbd className="rounded-md border border-border bg-surface px-2 py-0.5 text-xs font-medium text-foreground">
                        {key}
                    </kbd>
                </span>
            ))}
        </div>
    );
};

export const KeyboardShortcutsModal: React.FC = () => {
    return (
        <div className="max-h-[70vh] space-y-6 overflow-y-auto pr-1">
            <div className="space-y-6">
                {sections.map((section) => (
                    <div key={section.title} className="space-y-3">
                        <div className="space-y-1">
                            <h3 className="text-sm font-semibold text-foreground">
                                {section.title}
                            </h3>
                        </div>
                        <div className="divide-y divide-border rounded-lg border border-border">
                            {section.items.map((item) => (
                                <div
                                    key={`${section.title}-${item.label}`}
                                    className="flex flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center sm:justify-between"
                                >
                                    <div className="text-sm text-foreground">
                                        <p className="font-medium text-foreground">{item.label}</p>
                                        {item.description && (
                                            <p className="text-xs text-muted-foreground">
                                                {item.description}
                                            </p>
                                        )}
                                    </div>
                                    <KeyCombo keys={item.keys} />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
